import React from 'react';
import { compose } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './availDatepicker.js';
import Datepicker from '@synergycms_core/components/generic/Datepicker';
import { connect } from 'react-redux';
import RichText from '@synergycms_core/components/generic/RichText';
import { Map, List, fromJS } from 'immutable';
import { parseAvail } from '@synergycms_app/store/avail/availUtils'
import actions from '../../../store/actions';
import moment from 'moment';
import Price from '@synergycms_core/components/generic/Price';
import Tabs, { Tab } from '../../generic/TabList';
import TooltipWrapper from '@synergycms_core/components/generic/TooltipWrapper';
import { parseRestriccions } from '@synergycms_core/components/functional/Engine/engineUtils';
import { formatCurrencyAmount } from '@synergycms_core/utils/utils';
import ParamsParser from '@synergycms_core/utils/paramsParser';
import { showPopover } from '@synergycms_core/components/providers/popoverProvider.jsx';

class AvailDatepickerDay extends React.Component {
  static displayName = 'AvailDatepickerDay';

  render() {
    const { config, theme } = this.props;
    const { classes } = theme.styles;
    // day fields : day, stringDate, isSelected, startRange, endRange, disabled, 
    const { day, data, showTaxes, validCurrency } = config;
    let price = !!day && !!data && (showTaxes ? data.get('price_tax') : data.get('price'));


    const hasRestricccions = !!data && data.get('applied_restrictions') && !!data.get('applied_restrictions').size;
    const disableTooltip = !day || !hasRestricccions;
    return (
      <div className={[classes.dayContainer, (hasRestricccions && !!day) && classes.priceWithRestriction].join(' ')}>
        <TooltipWrapper
          enablePropagation={true}
          autoCloseTimeout={6000}
          family={"EngineDatepickerTooltip"}
          popoverStyle={[classes.tooltipCalendar,!hasRestricccions && classes.displacedCloseButton].join(' ')}
          typeTooltip={!!day && "tooltipDay" + day.format("D")}
          disabled={disableTooltip}
          removeTooltipTimeout={0}
          bottomLimit={100}
          avoidPointer={true}
          popover={(toogleTooltip, forceCloseTooltip) => {
            return (<div className={classes.restrictionContainer}>
              {hasRestricccions &&
                <RichText translate={true} ucFirst={true} withVars={data.get('applied_restrictions').first().toJS()} text={parseRestriccions(data.getIn(['applied_restrictions',0,'type']))} />
              }
            </div>);
          }}
          posX={'middle'}
          posY={'top'}
        >
          <div>
            <RichText text={!!day && day.format("D")} innerStyle={[classes.dayText, (!day && classes.noDispoDayText)]} />
            {price && <Price innerStyle={[classes.priceText, data.bestPrice && classes.bestPrice]} amount={price} hideDecimals={true} forceSymbol={true} hideSymbol={!validCurrency} formatPrice={!validCurrency} tabIndex={0}/>}
          </div>
        </TooltipWrapper>
      </div>
    );
  }
}


const NoAvailDatepickeDay = compose(
  PropertyManager(["day", "stringDate", "isSelected", "startRange", "endRange", "disabled", "data", "showTaxes", "parsePrice", "finalCurrency", "hotelCurrency", "validCurrency"]),
  withThemeJSS({ styleFile: styleFile, link: true })
)(AvailDatepickerDay)

class AvailDatepicker extends React.Component {
  static displayName = 'AvailDatepicker';

  constructor(props) {
    super(props);
    this.state = {
      startMonth: props.config.start,
      currentFirstMonth: props.config.start, months: props.theme.deviceType === 'MOBIL' ? 4 : 2
    };
  }

  componentDidMount = () => {
    this.props.config.newRange(this.state);
  }

  newRange = (configRange) => {
    const { currentFirstMonth } = configRange;
    this.setState({ startMonth: currentFirstMonth });
    this.props.config.newRange(configRange);
  }

  render() {
    const { config, theme } = this.props;
    const { classes } = theme.styles,
      {
        finalCurrency,
        hotelCurrency,
        showTaxes,
        validCurrency,
      } = config;
    let boardList = (config.boards && config.boards);
    if (config.hideBoards && boardList) {
      const freeBreakFastBoard = config.boards.find((board)=> {
          return board.get('freeBreakFast') && board.get('board_code') !== "14";
        })
        const baseBoard = !freeBreakFastBoard && config.boards.find((board)=> {
            return !board.get("freeBreakFast") && board.get('board_code') === "14";
        })
        const defaultFirstBoard = !freeBreakFastBoard && !baseBoard &&  config.boards.first();
        const finalBoard = freeBreakFastBoard || baseBoard || defaultFirstBoard;
        boardList = [finalBoard];
    }

    const hasPriceOrTax = boardList.some(board => {
      const parsedRanges = board.get('parsedRange');
      return parsedRanges && parsedRanges.some(dayConfig => {
        return dayConfig.has('price') || dayConfig.has('price_tax');
      });
    });

    //hideSingleTab
    return (
      <Tabs titleBlockStyle={'listNoDatepicker'} hideSingleTab={config.hideBoards || boardList.first().get("id", 0) === 0}>
        {boardList.map((board) => {
          return (<Tab
            contentKey={board.get("board_id")}
            key={board.get("board_id")}
            innerStyle={[theme.computedInnerStyle, classes.AvailDatepickerCalendar]}
            tabTitle={{
              richText: {
                innerStyle: ['uppercase'],
                text: board.get("name")
              },
              innerStyle: [classes.tabTitle, 'capitalize']
            }}>
              <>
                <Datepicker
                  onRangeChange={(dates) => {
                    if (dates.start && dates.end) {
                      config.closeByFamily("EngineDatepickerTooltip");
                    }
                    config.onRangeChange(dates);
                  }}
                  start={config.start}
                  end={config.end}
                  onScroll={()=>{
                      config.closeByFamily("EngineDatepickerTooltip");
                  }}
                  mobileArrows={config.mobileArrows}
                  firstMonth={moment(this.state.startMonth)}
                  months={config.months}
                  innerStyle={'noAvailAlertDatepicker'}
                  minDate={moment()}
                  dayTemplate={
                    board && ((dayConfig) => {
                      return <NoAvailDatepickeDay
                        config={dayConfig}
                        showTaxes={showTaxes}
                        data={board.getIn(["parsedRange", dayConfig.stringDate])}
                        finalCurrency={finalCurrency}
                        hotelCurrency={hotelCurrency}
                        parsePrice={config.parsePrice}
                        validCurrency={validCurrency}/>;
                    })
                  }
                  onChangeCalendar={this.newRange}
                />
                {hasPriceOrTax &&
                  <div className={[theme.computedInnerStyle, classes.dateChangeButton].join(' ')}>
                  <div className={classes.aclarationDatepickerTextContainer}>
                    {validCurrency ? <RichText
                      innerStyle={classes.aclarationDatepickerText}
                      ucFirst={true}
                      translate={true}
                      text={'_%* Precios aproximados%_'}
                    /> : 
                    <>
                      <RichText
                        innerStyle={classes.aclarationDatepickerText}
                        ucFirst={true}
                        translate={true}
                        text={'_%* Precios aproximados en%_'}/>
                      {' '}
                      <RichText
                        innerStyle={classes.aclarationDatepickerText}
                        ucFirst={true}
                        translate={true}
                        text={finalCurrency.get("code")}/>
                    </>
                    }
                  </div>
                </div>
                }
              </>
          </Tab>);
        })}
      </Tabs>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps, state) => {
  return {
    newRange: ({ currentFirstMonth, months }) => {
      const occups = ownProps.occups;
      const selected = ownProps.selectedSearch;
      const hotels = selected && selected.id && selected.code ? selected.id : null;
      const current = moment();
      const start = current > currentFirstMonth ? current : moment(currentFirstMonth).startOf("month");
      const end = moment(start).add(months - 1, "month").endOf("month");

      dispatch(actions.availCalendar.getAsync(start, end, fromJS({occups, hotels})));
    },

  };
};




const mapStateToProps = (store, ownProps) => {
  let data = null;
  const hotel = store.getIn(["customer", "current_hotel"]);
  //store.getIn(['availCache', params.get("hotelId") || store.get("group"), availQuery]);
  const hotelState = store.getIn(['hotels', hotel], Map());

  const occups = ownProps.occups;
  const selected = ownProps.selectedSearch;
  let hotelId = null;
  if(selected && selected.id && selected.code){
    hotelId = selected.id;
  } else if(selected && selected.hotelCode){
    hotelId = hotel;
  }

  let stringParams;
  if(ownProps.inAvail && (occups || hotelId)) {
    stringParams = store.getIn(['hotels', hotel, 'params', store.getIn(["availQuery", "mono", "base_string_calendar"])]);
  } else if (occups || hotelId) {
    let calendarParams = store.getIn(["customer", "params", 'calendar_params']);

    if(occups) {
      calendarParams = calendarParams.set("occups", fromJS(occups));
    }
    if(hotelId) {
      calendarParams = calendarParams.set("hotelId", hotelId);
    }
    stringParams = ParamsParser.paramsToQuery(calendarParams);
  } else {
    stringParams = store.getIn(['hotels', hotel, 'params', store.getIn(["availQuery", "mono", "string_calendar"])]);
  }

  const currentCurrencyCode = store.getIn(['customer', 'current_currency']) || undefined;
  const currencies = store.getIn(['customer', 'currencies'], List());
  const queryParams = store.getIn(['customer', 'params', 'url_params']);


  const validCurrency = (["EUR", "USD", "GBP"]).includes(currentCurrencyCode);

  var currentHotel = selected ? hotelId : hotel;
  if(currentHotel) {
    const hotelAvailData = store.getIn(['availCalendar', currentHotel, stringParams], Map());
    const roomId = ownProps.roomId;
    if ( !hotelAvailData.getIn(["raw_response", "requested"])) {
      data = (hotelAvailData.get("raw_response") && parseAvail(
        hotelAvailData.get("raw_response"),
        hotelAvailData.get('minPrice'),
        hotelAvailData.get('maxPrice'),
        hotelAvailData.get('freeBreakFast'),
        hotelState.get("show_taxes", true),
        roomId
      ));
    } else {
      data = hotelAvailData.get("response");
    }
  }
  let boardList;

  if (data && !data.get("requested")) {
    //data = data.getIn(["boardList", 0, "baseRange"], List());
    boardList = data.getIn(["boardList"]).reduce((boardList, board) => {
      return boardList.push(board.set("parsedRange", board.get("baseRange").reduce((acc, val) => {
        return acc.set(val.get("checkin"), val);
      }, Map())));
    }, List());
  }
  const hotelCurrency = ownProps.hotelCurrencyCode ||
  store.getIn(['hotels', store.getIn(['customer', 'current_hotel']), 'currency', 'code']) || // Monohotel
  (store.get('hotels').find((v, k) => Number.isFinite(+k)) || Map()).getIn(['currency', 'code']); // Multihotel

  //si no recibe props usar moment(queryParams)
  //si recibe props y no son null moment(props), puede ser null al no seleccionar fecha en busqueda
  let start, end 
  if(ownProps.start === undefined){
    start = moment(queryParams.get("start"));
  }else{
    start = (ownProps.start !== null) ? moment(ownProps.start) : null
  }
  if(ownProps.end === undefined){
    end = moment(queryParams.get("end"));
  }else{
    end = (ownProps.end !== null) ? moment(ownProps.end)  : null
  }
  
  
  

  return {
    start,
    end,
    showTaxes: hotelState.get('show_taxes'),
    boards: boardList || List([Map({ baseRange: List(), board_id: 0, name: 'Calendar' })]),
    finalCurrency: currencies.find(c => c.get('code') === currentCurrencyCode),
    langInfo: store.getIn(['customer', 'lang_info']),
    currentCurrencyCode: currentCurrencyCode,
    parsePrice: formatCurrencyAmount(currencies, currentCurrencyCode, store.getIn(['customer', 'lang_info'])),
    hotelCurrency: currencies.find(c => c.get('code') === hotelCurrency),
    validCurrency: validCurrency,

  };
};

//onRangeChange={this.updateRange}
//start={start}
//end={end}
//months={2}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  showPopover,
  PropertyManager(['occups', 'selectedSearch', 'onRangeChange', 'start', 'end', 'months', 'mobileArrows', 'boards', 'onChangeCalendar', 'roomId', 'showTaxes', 'datepickerStyle', 'parsePrice',"hotelCurrency", 'finalCurrency', 'newRange', 'hideBoards', 'closeByFamily', 'validCurrency']),
  withThemeJSS({ styleFile, link: true })
)(AvailDatepicker);
